/**
 * Moderation Topic Detail Header Section
 *
 * Displays hero section with topic information
 */

import type { ModerationCommunity } from '@moderation/domain/ModerationCommunity';
import { Heading } from '@soteria/design-system-ve';

import * as styles from './ModerationTopicDetailHeaderSection.css';

interface ModerationTopic {
  id: string;
  name: string;
  description: string;
}

interface ModerationTopicDetailHeaderSectionProps {
  community: ModerationCommunity | null;
  topic: ModerationTopic | null;
  isLoading: boolean;
}

export function ModerationTopicDetailHeaderSection({ community: _community, topic, isLoading }: ModerationTopicDetailHeaderSectionProps) {
  if (isLoading || !topic) {
    return (
      <div className={styles.heroSection}>
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <div className={styles.loadingState}>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.heroSection}>
      <div className={styles.heroOverlay} />

      <div className={styles.heroContent}>
        <div className={styles.topicHeader}>
          <Heading className={styles.topicTitle} level="h1">
            {topic.name}
          </Heading>
          <p className={styles.topicDescription}>{topic.description}</p>
        </div>
      </div>
    </div>
  );
}
